import type { PlaidProduct } from './generated/gql-enums';

export const PLAID_PRODUCT_INVESTMENTS = 'investments' satisfies PlaidProduct;
export const PLAID_PRODUCT_TRANSACTIONS = 'transactions' satisfies PlaidProduct;
